export const en = {
  title: 'Notifications',
  empty: 'No new notifications',
  reciprocalMessage: '%{name} added you to their Working Circle',
  socialOverlapMessage: 'Your colleagues also have %{name} in their circle',
  addThemBack: 'Add them back',
  dismiss: 'Dismiss',
}

export const es = en
